<script lang="ts">
	import ImagesBox from '$lib/components/Box/ImagesBox.svelte';
	import SectionInformationBlock from '$lib/components/Contentblocks/SectionInformationBlock.svelte';
	import { classes } from '$lib/utils';
	import { getTranslate } from '@tolgee/svelte';
	import CourseContentHighlights from '../CourseContentHighlights.svelte';

	export let id: string = '';

	const { t } = getTranslate();

	export let highlights: Array<string>;
	export let imageUrls: [string, string, string, string, string, string];
	export let additionalClass = '';

	$: sectionTitle = $t('section-title.takeaways.course-detail');
	$: title = $t('title.takeaways.course-detail');
	$: description = $t('description.takeaways.course-detail');
	// $: highlightsTitle = $t('title.highlights.course-detail');
</script>

{#if highlights && highlights.length > 0}
	<SectionInformationBlock
		additionalClass={classes(additionalClass, '')}
		{id}
		{sectionTitle}
		{title}
		{description}
	>
		<div class="grid grid-cols-1 gap-24 mr-auto">
			{#if highlights}
				<CourseContentHighlights
					titleClasses="font-bold text-2xl uppercase"
					icon="CheckMarkCircleIcon"
					iconClasses="w-5 h-5 mt-1"
					{highlights}
				/>
			{/if}
			{#if imageUrls && imageUrls.length === 6}
				<ImagesBox {imageUrls} />
			{/if}
		</div>
	</SectionInformationBlock>
{/if}
